import React from 'react'
import {RegistrationButtonSkin} from '../../registration-buttons/registration-button-skin'
import {Container} from '../common/container'
import {Subtitle} from '../common/subtitle'
import {Title} from '../common/title'
import {OrderFailedProps} from './index'

export const OrderFailed: React.FC<OrderFailedProps> = ({t, buttonStyle, navigateToMainPage}) => (
  <Container dataHook="order-failed">
    <div style={{textAlign: 'center'}}>
      <Title text={t('paymentError.paymentCanceledTitle')} />
      <Subtitle lines={[t('paymentError.paymentCanceledDescription')]} />
      <RegistrationButtonSkin
        text={t('paymentError.buttonText')}
        buttonStyle={buttonStyle}
        onClick={() => navigateToMainPage()}
      />
    </div>
  </Container>
)
